<h1>Communicator</h1>
<div mat-dialog-content>
  <form [formGroup]="emailTemplateForm">
    <div fxLayout="column">
      <span class="mat-body-1" style="color:rgb(25,118,210);width:100%;">Send a message:</span>
      <div fxLayout="column" style="width:100%;">
        <mat-form-field>
          <textarea placeholder="Subject" name="subject" autocomplete="false" rows="1" matInput formControlName="subject"
            required></textarea>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="HTML Template" name="htmlMappingTemplate" formControlName="htmlMappingTemplate"
            required>
            <mat-option *ngFor="let htmlMappingTemplate of data.htmlMappingTemplates" [value]="htmlMappingTemplate.id"
              (click)="getLanguageTemplates(htmlMappingTemplate.id)">{{htmlMappingTemplate.templateName}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="Language" name="htmlLanguageTemplates" formControlName="htmlLanguageTemplate"
            required>
            <mat-option *ngFor="let htmlLanguageTemplates of htmlLanguageTemplates$ | async" [value]="htmlLanguageTemplates.language">{{htmlLanguageTemplates.language}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="
              Message Template" name="messageTemplate" formControlName="messageTemplate">
            <mat-option *ngFor="let messageTemplate of data.directMessageTemplates" [value]="messageTemplate.id"
              (click)="setMessageBody(messageTemplate)">{{messageTemplate.templateName}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <textarea placeholder="Message Body" name="messageBody" autocomplete="false" rows="7" matInput
            formControlName="messageBody" required></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>

</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button [mat-dialog-close]="emailTemplateForm.value" cdkFocusInitial color="primary" [disabled]="!emailTemplateForm.valid">Send</button>
</div>